export default __webpack_public_path__ + "static/media/3.34bc1936.webp";